import { useEffect, useRef } from 'react'
import getDeviceId from 'core/utils/getDeviceId'

/**
 * @description 等待页面加载完成的 Promise 函数。
 * @returns {Promise<null>} - 当页面加载完成后 resolve 的 Promise。
 */
function waitForLoad() {
  return new Promise((resolve) => {
    if (document.readyState === 'complete') {
      resolve(null)
    } else {
      window.addEventListener('load', resolve)
    }
  })
}

/**
 * @description 用于检查并切换可用接口 API 线路的 Hook。
 *  该 Hook 仅在客户端执行一次，用于在页面加载完成后动态检查和切换 API 线路，
 *  确保应用在不同网络环境下都能正常访问 API。
 */
const useApiEndpointSwitcher = () => {
  // 使用 useRef 确保 checkEndpoints 只执行一次
  const hasExecuted = useRef(false)
  let timer

  useEffect(() => {
    // 检查是否已执行，以及是否在客户端环境
    if (!hasExecuted.current && typeof window !== 'undefined') {
      // 等待页面加载完成后执行
      waitForLoad().then(() => {
        clearTimeout(timer) // 清除之前的定时器
        timer = setTimeout(() => {
          // 如果页面是/xxx/error/，其中xxx是任意字符,
          // 此页面会在worker中根据请求是白名单外的国家会被重定向进来，避免浪费fingerprint和API调用请求
          if (location.pathname.match(/\/\w+\/error\//)) {
            return
          }
          getDeviceId()
          // 动态导入 checkEndpoints 函数，并执行 API 线路检查
          import('core/utils/domain').then(({ checkEndpoints }) => {
            checkEndpoints()
          })
        }, 2000) // 延迟 2 秒执行，确保页面加载完成
      })
      // 设置为已执行，防止重复执行
      hasExecuted.current = true
    }
  }, []) // 依赖项为空数组，确保只执行一次
}

export default useApiEndpointSwitcher
